import { forwardRef } from 'react'
import type { InputHTMLAttributes, ReactNode, TextareaHTMLAttributes } from 'react'

import { cn } from '@/shared/lib/cn'

import { CONTROL } from './Select'

// El desplegable vive en su propio archivo: dejó de ser un `<select>` con estilo.
export { Select } from './Select'

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...props }, ref) {
    return <input ref={ref} className={cn(CONTROL, 'h-7', className)} {...props} />
  },
)

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(function Textarea({ className, ...props }, ref) {
  return (
    <textarea ref={ref} className={cn(CONTROL, 'py-1.5 leading-relaxed', className)} {...props} />
  )
})

export interface FieldProps {
  label: string
  htmlFor?: string
  hint?: ReactNode
  children: ReactNode
  className?: string
}

export function Field({ label, htmlFor, hint, children, className }: FieldProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <label htmlFor={htmlFor} className="text-2xs tracking-wide text-text-3 uppercase">
        {label}
      </label>
      {children}
      {hint ? <p className="text-2xs text-text-3">{hint}</p> : null}
    </div>
  )
}
